import MobileNavBar from './MobileNavBar';
import React from 'react';
import { Box } from '@mui/material';
import { ReactComponent as LogoShape } from 'assets/LogoShape.svg';

interface MobilePageLayoutProps {
  children?: React.ReactNode;
  backgroundHeight?: string; // Let pages control how much of the gradient to show
}

const MobilePageLayout = ({ children, backgroundHeight = '0vh' }: MobilePageLayoutProps) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden', // Prevent layout from scrolling
      }}
    >
      {/* Fixed Background with Logo */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: backgroundHeight,
          background: 'linear-gradient(131deg, #030B1B 41.65%, #2D3F64 88.19%)',
          zIndex: 0,
          overflow: 'hidden',
        }}
      >
        {/* Background Logo */}
        <Box
          sx={{
            position: 'absolute',
            top: -15,
            right: -95,
            opacity: 1.0,
            mixBlendMode: 'overlay',
          }}
        >
          <LogoShape style={{ width: 460, height: 460 }} />
        </Box>
      </Box>

      {children}

      {/* Fixed Navigation */}
      <MobileNavBar />
    </Box>
  );
};

export default MobilePageLayout;
